
import axiosNew from "../../../helpers/axios"
import { buildQueryParams } from "../../../utils/commonUtils"


export const getInspirationCategory = async () => {


    // Construct base URL
    let url = `inspiration-category/list`;


    return new Promise(async (resolve) => {
        try {
            const payload = {
                limit: 100
            };
            const res = await axiosNew({
                url,
                method: "POST",
                data: payload
            });
            resolve({ data: res.data ?? {} });
        } catch (error) {
            console.log("🚀 ~ getInspirationCategory ~ error:", error)
            resolve({ data: error?.response?.data ?? {} });
        }
    });
};


